export default {
  // List of pages where Header is not rendered
  ignorePages: [
    'eticket', 'invite'
  ],
}
